export default __webpack_public_path__ + "static/media/kheng.3a9c3096.jpg";